import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { getUnreadNotificationCount } from '../../redux/api';
import NotificationCenter from './NotificationCenter';

const NotificationBell = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotificationCenter, setShowNotificationCenter] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUnreadCount();
    
    // Poll for unread count every 30 seconds
    const interval = setInterval(() => {
      fetchUnreadCount();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      setLoading(true);
      const response = await getUnreadNotificationCount();
      setUnreadCount(response.data.unreadCount || 0);
    } catch (error) {
      console.error('Error fetching unread count:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowNotificationCenter(true)}
        className="relative p-2 text-gray-300 hover:text-white transition-colors focus:outline-none"
        title="Notifikacije"
      >
        <Bell className="w-6 h-6" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
      
      <NotificationCenter
        isOpen={showNotificationCenter}
        onClose={() => {
          setShowNotificationCenter(false);
          fetchUnreadCount(); // Refresh count when closing
        }}
      />
    </>
  );
};

export default NotificationBell;

